import { render } from "./SalaryMgt.vue?vue&type=template&id=1151f6d4"
import script from "./SalaryMgt.vue?vue&type=script&lang=js"
export * from "./SalaryMgt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__